module.exports = __webpack_public_path__ + "static/media/vtm-25000-1952-1957.510acb5b.png";